<stx-generic-wide-page>
  <stx-report-header>
    {{ 'reports.orthodontic_treatments' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.initialized$ | async) {
  <stx-orthodontic-treatment-report-table></stx-orthodontic-treatment-report-table>
  }
</stx-generic-wide-page>
